Vue.asyncComponent('bp-skin-settings-form', {
    data() {
        return {
            loading: false,
            formData: null,
            settings: {},
            minWidth: null,
            width: null,
        }
    },
    model: {
        prop: 'settingValues',
        event: 'change'
    },
    props: {
        dataProvider: {
            type: Object,
            default: false
        },
        blueprintId: {
            type: String|Number,
        },
        verticalId: {
            type: String|Number,
        },
        settingValues: {
            type: Object,
            default: () => {}
        },
        fullWidth: {
            type: Boolean,
        }
    },
    computed: {
        /**
         * The current relation string
         * @returns {*}
         */
        relationString() {
            return this.$route.params.relationString;
        },
        /**
         * The current relation string
         * @returns {*}
         */
        query() {
            return this.$route.params.query;
        },
        /**,
         * Get the url for this settingForm form
         * @returns {string}
         */
        formUrl() {
            return this.dataProvider.getSkinSettingsHandler().getSkinSettingsFormUrl(this.verticalId);
        },
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return `skin-settings-form-width`;
        }
    },
    methods: {
        /**
         * Get the formData needed for the Settingsform
         * @returns {Promise<void>}
         */
        async getFormData() {
            let params = {
                locale: this.$localeHandler.getActiveLocale()
            };
            this.loading = true;

            try {
                this.formData  = await this.$get(this.formUrl, params);
                this.setInitialSettingValues();

                this.loading = false;
            } catch (error) {
                console.log(error);
            }
        },
        /**
         * Set the initial setting variable
         */
        setInitialSettingValues() {
            this.formData.form.controlWidgets.widgets.forEach(widget => {
                this.settings[widget.id] = widget.formControl.value;
            });

            this.$emit('change', this.settings);
        },
        /**
         * Update current settings
         * @param formValues
         */
        updateSettingValues(formValues) {
            this.settings = formValues;
            this.$emit('change', this.settings);
        },
        /**
         * Notify the parent that we wan't to apply the current settings
         */
        doApply() {
            this.$emit('apply', this.settings);
            this.$emit('close');
        },
        /**
         * Set the current minWidth
         * @param minWidth
         */
        setMinWidth(minWidth) {
            this.minWidth = minWidth;
        },
        /**
         * Update width
         *
         * Update the current width for this bundle and definition
         * @param width
         */
        updateWidth(width) {
            this.width = width;

            if (! this.fullWidth) {
                // We keep the current width in the local storage so when the user comes back tot this form we will use the same width
                localStorage.setItem(this.localStorageWidthId, this.width);
            }
        },
        close() {
            this.$emit('close');
        }
    },
    created() {
        this.getFormData();

        if (this.fullWidth) {
            this.width = 'calc(100% - var(--drawer-width))';
        } else {
            // Check if we have a width for this form and definition in storage
            const widthInStorage = localStorage.getItem(this.localStorageWidthId);

            if (widthInStorage) {
                this.width = widthInStorage;
            }
        }
    }
}, 'blueprints/settings/bp-skin-settings-form.html');
